import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import Block from '../components/block'
import DefaultLayout from '../layouts/default_layout'

class ModalPage extends React.PureComponent {

  render() {
    const {
      children,
      title,
      page,
    } = this.props

    return (
      <DefaultLayout
        noRightSidebar
        noComposeButton
        title={title}
        page={page}
        showBackBtn
      >
        <PageTitle path={title} />
        
        <div className={[_s.d, _s.w100PC].join(' ')}>
          <Block>
            <div className={[_s.d, _s.py15, _s.px15].join(' ')}>
              {children}
            </div>
          </Block>
        </div>
      </DefaultLayout>
    )
  }

}

ModalPage.propTypes = {
  title: PropTypes.string,
  page: PropTypes.string,
  children: PropTypes.node,
}

export default ModalPage